
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ClientListing from '@/app/components/clients/ClientListing.vue';
import debounce from 'lodash/debounce';
import { clientTableFields } from './tableFields/clientTableFields';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import { ExportListType, ListSortParams } from 'ah-api-gateways';

@Component({
  components: {
    ClientListing,
    ListDownloadButton,
  },
})
export default class SearchableClientList extends Vue {
  $refs!: {
    clientListing: ClientListing;
  };

  @Prop({ default: () => ({}) }) commonFilters!: any;

  @Prop({ default: false }) showExport!: boolean | string;

  // Automatically syncronised via .sync
  private dataDownloadState = 'idle';

  @Prop({
    default: () => clientTableFields,
  })
  tableFields!: any;

  get clientsConfig() {
    return {
      tableFields: this.tableFields,
    };
  }

  private userFilters: any = {};

  private sortAndPageParams: Partial<ListSortParams> = {};

  private filter = {};

  private debouncedFilterChange!: Function;

  created() {
    this.filter = { ...this.commonFilters, ...this.userFilters };

    this.debouncedFilterChange = debounce(() => {
      this.filter = { ...this.commonFilters, ...this.userFilters };
    }, 1500);
  }

  downloadList(format: ExportListType) {
    this.$refs.clientListing.downloadData(format);
  }

  @Watch('userFilters')
  onFiltersChange() {
    this.debouncedFilterChange();
  }

  setFilters(filters: any) {
    this.userFilters = filters;
  }

  setSortAndPageParams(params: Partial<ListSortParams>) {
    this.sortAndPageParams = params;
  }

  onSuccess() {
    this.$refs.clientListing.loadData();
  }
}
